import { gameState } from '../index';

let sound = true;
let settings = false;
let interacted = false;
let call = 0;
let animsList = [];
let value = 0;
let round = 0;
let rect;
let circX = 530;
let bar = [];
let questionCount = 4;
let questions = [5, 6, 7, 8, 9, 10, 11, 12, 13];
let change = false;

export default class HintScene extends Phaser.Scene {
  constructor() {
    super({
      key: 'HintScene',
    });
  }

  preload() {}

  create() {
    sound = true;
    settings = false;
    interacted = false;
    call = 0;
    animsList = [];
    value = 0;
    round = 0;
    circX = 530;
    bar = [];
    questionCount = 4;
    questions = [5, 6, 7, 8, 9, 10, 11, 12, 13];
    change = false;

    // Hint system
    this.hintAnimations();
    this.overlay = this.add.image(0, 0, 'overlay').setOrigin(0).setAlpha(0);

    this.hintText = this.add.image(72, 656, 'hint1').setOrigin(0, 1).setScale(0);

    this.hintButton = this.physics.add
      .sprite(-25, 550, 'hintFinalAnim')
      .setOrigin(0)
      .setScale(0.8)
      .setInteractive({ cursor: 'pointer', pixelPerfect: true });

    this.hintClose = this.add
      .image(516, 406, 'hintClose')
      .setOrigin(0)
      .setAlpha(0)
      .setInteractive({ cursor: 'pointer' });

    this.hintButton.on('pointerdown', () => {
      gameState.hintAttempted++;
      if (gameState.wrongAttempt == 1) this.hintText.setTexture('hint1');
      else this.hintText.setTexture('hint2');

      this.hintClose.y = 656 - 30 - this.hintText.height;

      this.tera.setTexture('teraIdea');
      this.tera.anims.play('teraIdea');
      this.time.delayedCall(
        2000,
        () => {
          this.tera.anims.play('teraIdle');
        },
        [],
        this,
      );

      this.hintButton.play('idle');
      this.scene.pause('GameScene');
      this.overlay.setAlpha(1);

      this.tweens.add({
        targets: [this.hintText],
        scale: 1,
        duration: 500,
        ease: 'Sine.easeInOut',
        onComplete: () => {
          this.hintClose.setAlpha(1);
        },
      });
    });

    this.hintClose.on(
      'pointerdown',
      () => {
        this.scene.resume('GameScene');
        this.overlay.setAlpha(0);
        this.hintText.setScale(0);
        this.hintClose.setAlpha(0);
      },
      this,
    );

    // Game UI layout and functionalities
    this.bar = this.add.image(0, 0, 'mask').setOrigin(0);
    this.shape = this.make.graphics();
    this.shape.beginPath();
    this.shape.fillRect(0, 75, 1280, 150);
    this.mask = this.shape.createGeometryMask();

    this.dropDown = this.add.image(1220, 145, 'dropDown').setOrigin(0.5, 0.5);
    this.sound = this.add
      .image(1220, 132, 'sound')
      .setOrigin(0.5, 0.5)
      .setDepth(2)
      .setScale(0.75)
      .setInteractive({ cursor: 'pointer' });
    this.fullScreenOff = this.add
      .image(1220, 185, 'fullScreenOff')
      .setDepth(2)
      .setOrigin(0.5, 0.5)
      .setScale(0.73)
      .setInteractive({ cursor: 'pointer' });

    this.progressBar = this.add.image(516, 8, 'progressBar').setOrigin(0);

    // Tera animation states
    this.animCreate('teraIn', 'teraIn', 0, 30, 'teraIn', 30, 0);
    animsList.push('teraIn');
    this.animCreate('teraIdle', 'teraIdle', 0, 40, 'teraIdleBlink', 24, -1);
    animsList.push('teraIdle');
    this.animCreate('teraCorrect', 'teraCorrect', 0, 111, 'teraCorrect', 30, 0);
    animsList.push('teraCorrect');
    this.animCreate('teraWrong', 'teraWrong', 0, 114, 'teraWrong', 30, 0);
    animsList.push('teraWrong');
    this.animCreate('teraThinkStart', 'teraThink', 0, 30, 'teraThink', 30, 0);
    animsList.push('teraThinkStart');
    this.animCreate('teraThinkLoop', 'teraThink', 31, 90, 'teraThink', 30, 0);
    animsList.push('teraThinkLoop');
    this.animCreate('teraThinkLoopReverse', 'teraThink', 90, 31, 'teraThink', 30, 0);
    animsList.push('teraThinkLoopReverse');
    this.animCreate('teraThinkOut', 'teraThink', 91, 111, 'teraThink', 30, 0);
    animsList.push('teraThinkOut');
    this.animCreate('teraIdea', 'teraIdea', 0, 82, 'teraIdea', 30, 0);
    animsList.push('teraIdea');
    this.animCreate('teraOut', 'teraOut', 0, 25, 'teraOut', 30, 0);
    animsList.push('teraOut');
    this.holder = this.add.image(70, 42, 'holder').setOrigin(0);
    this.holder.displayWidth = 0;
    this.s1 = this.add.image(168, 76, 's1').setOrigin(0).setAlpha(0);
    this.tera = this.add.sprite(75, 93, 'teraIn').play('teraIn');

    this.textHolderTween(1002, 500, 50);
    rect = this.add.rectangle(535, 18, 1, 5, 0xffcf56, 1).setOrigin(0);

    this.paused = this.add
      .image(0, 0, 'paused')
      .setDepth(2)
      .setOrigin(0)
      .setVisible(false);

    this.container = this.add
      .container(0, -130, [this.dropDown, this.sound, this.fullScreenOff])
      .setDepth(2);
    this.container.setMask(this.mask);

    this.yellow = this.add.image(1220, 72, 'yellow').setDepth(2).setOrigin(0.5, 0.5);
    this.circle = this.add
      .image(1220, 72, 'circle')
      .setDepth(2)
      .setOrigin(0.5, 0.5)
      .setInteractive({ cursor: 'pointer' });

    this.animCreate('pause', 'playAnim', 21, 21, 'playPause', 30, 0);
    this.animCreate('pausePlay', 'playAnim', 21, 39, 'playPause', 30, 0);

    this.pause = this.add
      .sprite(1125, 72, 'playAnim')
      .setDepth(2)
      .setInteractive({ cursor: 'pointer', pixelPerfect: true })
      .play('pause');
    this.pause.on(
      'pointerup',
      function () {
        if (this.paused.visible == false) {
          this.pause.anims.play('pausePlay');
          this.hintButton.disableInteractive();
          this.hintClose.disableInteractive();
          this.pauseAllScenes();
          this.scene.pause('GameScene');
          this.scene.pause('EndScene');
          for (let i = 0; i < animsList.length; i++) this.anims.get(animsList[i]).pause();
          this.game.sound.pauseAll();
          this.paused.setVisible(true);
        } else {
          this.hintButton.setInteractive();
          this.hintClose.setInteractive();
          this.resumeAllScenes();
          this.game.scene.resume('GameScene');
          this.scene.resume('EndScene');
          for (let i = 0; i < animsList.length; i++)
            this.anims.get(animsList[i]).resume();
          this.game.sound.resumeAll();
          this.pause.anims.playReverse('pausePlay', true);
          this.paused.setVisible(false);
        }
      },
      this,
    );

    this.circle.on(
      'pointerup',
      function () {
        settings = true;
        if (settings == true && this.container.y == -130) {
          settings = false;
          this.buttonScale(this.yellow, 0.9, 200, 50, 0);
          this.whiteCircleTween(60);
          this.time.delayedCall(
            200,
            () => {
              this.menuSlideDown(0);
            },
            [],
            this,
          );
        }
        if (settings == true && this.container.y == 0) {
          settings = false;
          this.buttonScale(this.yellow, 0.97, 75, 10, 0);
          this.buttonScale(this.dropDown, 0.97, 75, 10, 0);
          this.whiteCircleTween(-60);
          this.time.delayedCall(
            200,
            () => {
              this.menuSlideDown(-130);
            },
            [],
            this,
          );
        }
      },
      this,
    );

    this.sound.on(
      'pointerup',
      function () {
        sound = true;
        interacted = true;
        this.buttonScale(this.sound, 0.85, 75, 10, 0);
        if (this.bgMusic && this.bgMusic.volume == 0.1 && sound == true) {
          this.bgMusic.setVolume(0);
          this.sound.setTexture('mute');
          sound = false;
        }
        if (this.bgMusic && this.bgMusic.volume == 0.0 && sound == true) {
          this.bgMusic.setVolume(0.1);
          this.sound.setTexture('sound');
          sound = false;
        }
      },
      this,
    );

    this.fullScreenOff.on(
      'pointerup',
      function () {
        interacted = true;
        this.buttonScale(this.fullScreenOff, 0.83, 75, 10, 0);
        if (this.scale.isFullscreen) {
          this.scale.stopFullscreen();
          this.fullScreenOff.setTexture('fullScreen');
        } else {
          this.scale.startFullscreen();
          this.fullScreenOff.setTexture('fullScreenOff');
        }
      },
      this,
    );
  }

  pauseAllScenes() {
    this.scene.manager.scenes.forEach(function (scene) {
      if (scene.scene.isActive() && scene.scene.key != 'HintScene') {
        scene.scene.pause();
      }
    });
  }

  resumeAllScenes() {
    this.scene.manager.scenes.forEach(function (scene) {
      if (scene.scene.isPaused() && scene.scene.key != 'HintScene') {
        scene.scene.resume();
      }
    });
  }

  hintAnimations() {
    this.anims.create({
      key: 'pop',
      frames: this.anims.generateFrameNames('hintFinalAnim', {
        start: 0,
        end: 35,
        zeroPad: 0,
        prefix: 'seq_0_',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.anims.create({
      key: 'breathe',
      frames: this.anims.generateFrameNames('hintFinalAnim', {
        start: 36,
        end: 66,
        zeroPad: 0,
        prefix: 'seq_0_',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: -1,
    });

    this.anims.create({
      key: 'idle',
      frames: this.anims.generateFrameNames('hintFinalAnim', {
        start: 36,
        end: 37,
        zeroPad: 0,
        prefix: 'seq_0_',
        suffix: '.png',
      }),
      frameRate: 1,
      repeat: -1,
    });

    this.anims.create({
      key: 'pop_out',
      frames: this.anims.generateFrameNames('hintFinalAnim', {
        start: 35,
        end: 0,
        zeroPad: 0,
        prefix: 'seq_0_',
        suffix: '.png',
      }),
      frameRate: 60,
      repeat: 0,
    });

    animsList.push('pop');
    animsList.push('breathe');
    animsList.push('idle');
    animsList.push('idle');
  }

  wrong() {
    change = false;
    if (gameState.wrongAttempt == 1) this.hintButton.play('pop');

    this.time.delayedCall(
      500,
      () => {
        if (gameState.wrongAttempt <= 2) this.hintButton.play('breathe');
      },
      [],
      this,
    );

    if (
      this.tera.anims.currentAnim.key == 'teraIdle' ||
      this.tera.anims.currentAnim.key == 'teraWrong'
    ) {
      this.tera.setTexture('teraWrong');
      this.tera.anims.play('teraWrong');
    }

    if (
      this.tera.anims.currentAnim.key == 'teraThinkLoop' ||
      this.tera.anims.currentAnim.key == 'teraThinkLoopReverse'
    ) {
      this.tera.setTexture('teraThinkOut');
      this.tera.anims.play('teraThinkOut');
      this.tera.on(
        Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + 'teraThinkOut',
        () => {
          this.tera.setTexture('teraWrong');
          this.tera.anims.play('teraWrong');
        },
        this,
      );
    }

    this.tera.on(
      Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + 'teraWrong',
      () => {
        if (gameState.wrongAttempt <= 2) {
          this.tera.setTexture('teraThinkStart');
          this.tera.anims.play('teraThinkStart');
        }
        if (gameState.wrongAttempt > 2) {
          this.tera.setTexture('teraIdle');
          this.tera.anims.play('teraIdle');
          gameState.wrongState = true;
          const scene1 = this.scene.get('GameScene');
          gameState.cardDown = true;
          if (change == false) {
            gameState.wrongCount++;
            scene1.next();
            change = true;
          }
        }
      },
      this,
    );
    this.tera.on(
      Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + 'teraThinkStart',
      () => {
        this.tera.setTexture('teraThinkLoop');
        this.tera.anims.play('teraThinkLoop');
        this.teraThink();
      },
      this,
    );
  }

  teraThink() {
    this.tera.on(
      Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + 'teraThinkLoop',
      () => {
        this.tera.setTexture('teraThinkLoopReverse');
        this.tera.anims.play('teraThinkLoopReverse');
      },
      this,
    );

    this.tera.on(
      Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + 'teraThinkLoopReverse',
      () => {
        this.tera.setTexture('teraThinkLoop');
        this.tera.anims.play('teraThinkLoop');
      },
      this,
    );
  }

  correct() {
    if (
      this.tera.anims.currentAnim.key == 'teraThinkLoop' ||
      this.tera.anims.currentAnim.key == 'teraThinkLoopReverse'
    ) {
      this.tera.setTexture('teraThinkOut');
      this.tera.anims.play('teraThinkOut');
    }

    this.time.delayedCall(
      750,
      () => {
        this.tera.setTexture('teraCorrect');
        this.tera.anims.play('teraCorrect');
      },
      [],
      this,
    );

    if (round < 6) {
      if (round == 0) this.yellowCircleDraw();
      round++;
      if (round == 2) circX += 47;
      if (round >= 3) circX += 43;
    }
    this.tera.on(
      Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + 'teraCorrect',
      () => {
        this.tera.setTexture('teraIdle');
        this.tera.anims.play('teraIdle');
        gameState.correctAttempt = false;
        gameState.confirmClick = false;
        this.objectFadeOutIn(0, 1000, 250);
      },
      this,
    );
  }

  teraOut() {
    if (gameState.correctCount >= 6) {
      this.tera.setTexture('teraOut');
      this.tera.anims.play('teraOut');
    }
  }

  settingsAutoCollapse() {
    this.time.delayedCall(
      5000,
      () => {
        if (interacted == false) {
          this.menuSlideDown(-130);
        }
        if (interacted == true) call = 0;
      },
      [],
      this,
    );
  }

  buttonScale(object, scale, duration, delay, repeat) {
    this.tweens.add(
      {
        targets: object,
        scale: scale,
        ease: 'Sine.easeInOut',
        duration: duration,
        delay: delay,
        repeat: repeat,
        yoyo: true,
      },
      this,
    );
  }

  menuSlideDown(y) {
    this.tweens.add(
      {
        targets: this.container,
        y: y,
        ease: 'Linear',
        duration: 500,
        delay: 100,
        repeat: 0,
        onComplete: () => {
          if (y == 0) call = 0;
        },
      },
      this,
    );
  }

  whiteCircleTween(angle) {
    this.tweens.add(
      {
        targets: [this.circle],
        x: 1219,
        y: 70,
        ease: 'Sine.easeInOut',
        duration: 75,
        delay: 10,
        repeat: 0,
        yoyo: true,
        onComplete: () => {
          this.tweens.add(
            {
              targets: [this.circle],
              angle: angle,
              ease: 'Power1',
              duration: 500,
              delay: 25,
              repeat: 0,
            },
            this,
          );
        },
      },
      this,
    );
  }

  animCreate(key, frames, start, end, prefix, frameRate, repeat) {
    this.anims.create({
      key: key,
      frames: this.anims.generateFrameNames(frames, {
        start: start,
        end: end,
        prefix: prefix,
        suffix: '.png',
      }),
      frameRate: frameRate,
      repeat: repeat,
    });
  }

  textHolderTween(width, duration, delay) {
    change = false;
    this.tweens.add(
      {
        targets: this.holder,
        displayWidth: width,
        ease: 'Sine.easeInOut',
        duration: duration,
        delay: delay,
        repeat: 0,
        onComplete: () => {
          this.time.delayedCall(
            200,
            () => {
              if (width == 1002 && round == 0) this.objectFadeInOut(1, 1000, 250);

              if (round >= 1 && gameState.correctAttempt == false) {
                if (width == 0 && gameState.wrongState == false) {
                  const scene1 = this.scene.get('GameScene');
                  gameState.cardDown = true;
                  if (change == false) {
                    scene1.next();
                    change = true;
                  }
                }

                if (width == 1002) {
                  if (change == false) {
                    gameState.questionNo = Phaser.Math.RND.pick(questions);
                    for (let i = 0; i <= questions.length; i++) {
                      if (questions[i] == gameState.questionNo) {
                        questions.splice(i, 1);
                        break;
                      }
                    }
                    questionCount++;
                    change = true;
                  }
                  this.s1.setTexture('s' + gameState.questionNo);
                  this.s1.y = 45;
                  this.objectFadeInOut(1, 1000, 250);
                }
              }
            },
            [],
            this,
          );
          this.time.delayedCall(
            750,
            () => {
              if (width == 0 && gameState.wrongState == true) {
                if (questionCount < 13) this.textHolderTween(1002, 500, 50);
                if (questionCount >= 13) {
                  this.teraOut();
                  this.time.delayedCall(
                    1500,
                    () => {
                      const scene1 = this.scene.get('GameScene');
                      if (change == false) {
                        scene1.sceneEnd();
                        change = true;
                      }
                    },
                    [],
                    this,
                  );
                }
              }
            },
            [],
            this,
          );
        },
      },
      this,
    );
  }

  objectFadeInOut(alpha, duration, delay) {
    this.tweens.add(
      {
        targets: this.s1,
        alpha: alpha,
        ease: 'Cubic',
        duration: duration,
        delay: delay,
        repeat: 0,
        onComplete: () => {
          if (gameState.correctAttempt == false) {
            this.tera.setTexture('teraIdle');
            this.tera.anims.play('teraIdle');
          }

          this.time.delayedCall(
            2500,
            () => {
              if (round == 0 && gameState.correctAttempt == false) {
                if (this.s1.y != 45) this.objectFadeOutIn(0, 1000, 250);
                if (this.s1.y == 45) {
                  const scene1 = this.scene.get('GameScene');
                  scene1.handTween();
                }
              }
            },
            [],
            this,
          );

          this.time.delayedCall(
            300,
            () => {
              if (gameState.wrongState == true) {
                const scene1 = this.scene.get('GameScene');
                scene1.cardChange();
              }
            },
            [],
            this,
          );
        },
      },
      this,
    );
  }

  objectFadeOutIn(alpha, duration, delay) {
    change = false;
    this.tweens.add({
      targets: this.s1,
      alpha: alpha,
      ease: 'Cubic',
      duration: duration,
      delay: delay,
      repeat: 0,
      onComplete: () => {
        this.time.delayedCall(
          700,
          () => {
            if (round == 0) {
              if (gameState.correctAttempt == false) {
                this.s1.setTexture('s2');
                this.s1.y = 45;
              }
              if (gameState.correctAttempt == true && gameState.confirmClick == false) {
                this.s1.setTexture('s3');
                this.s1.y = 76;
              }
              if (gameState.correctAttempt == true && gameState.confirmClick == true) {
                this.s1.setTexture('s4');
                this.s1.y = 76;
                this.correct();
              }
              this.objectFadeInOut(1, 1000, 250);
            }

            if (round >= 1 && gameState.correctAttempt == false)
              this.textHolderTween(0, 500, 50);
            if (
              round >= 1 &&
              gameState.correctAttempt == true &&
              gameState.confirmClick == false
            ) {
              this.s1.setTexture('s4');
              this.s1.y = 76;
              if (change == false) {
                this.correct();
                change = true;
              }
              this.objectFadeInOut(1, 1000, 250);
            }

            if (
              round >= 1 &&
              gameState.wrongState == true &&
              gameState.correctAttempt == false
            ) {
              this.textHolderTween(0, 500, 50);
            }
          },
          [],
          this,
        );
      },
    });
  }

  yellowCircleDraw() {
    this.circle1 = new Phaser.Geom.Circle(circX, 21, 6);
    bar.push(this.circle1);
    this.yellow1 = this.add.graphics({ fillStyle: { color: 0xffdc83, alpha: 1 } });
    this.yellow1.fillCircleShape(this.circle1);
  }

  update() {
    if (gameState.correctAttempt == true) {
      if (round == 2) {
        if (value < 37) value += 1;
        if (value == 37) {
          this.yellowCircleDraw();
          value++;
        }
      }
      if (round == 3) {
        if (value < 80) value += 1;
        if (value == 80) {
          this.yellowCircleDraw();
          value++;
        }
      }
      if (round == 4) {
        if (value < 123) value += 1;
        if (value == 123) {
          this.yellowCircleDraw();
          value++;
        }
      }
      if (round == 5) {
        if (value < 166) value += 1;
        if (value == 166) {
          this.yellowCircleDraw();
          value++;
        }
      }
      if (round == 6) {
        if (value < 209) value += 1;
        if (value == 209) {
          this.yellowCircleDraw();
          value++;
          round++;
        }
      }

      rect.setDisplaySize(1 * value, 5);
      if (round == 7) {
        this.time.delayedCall(
          500,
          () => {
            rect.setFillStyle(0x3dd771, 1);
            this.green = this.add.graphics({
              fillStyle: { color: 0x3dd771, alpha: 1 },
            });
            for (let i = 0; i < bar.length; i++) {
              this.green.fillCircleShape(bar[i]);
              if (i == 5) {
                round = 8;
              }
            }
          },
          [],
          this,
        );
      }
    }
    if (this.container.y == 0 && call == 0) {
      call++;
      this.settingsAutoCollapse();
      interacted = false;
    }

    if (gameState.hintClose == true) {
      this.hintButton.play('pop_out');
      gameState.hintClose = false;
    }
  }
}
